import { PulseLoader } from "react-spinners";
import { theme } from "styles/mui-config";

function LoadingPartCM({ size = 10, color = theme.palette.primary.dark }) {
  return <PulseLoader color={color} size={size} />;
}

export default LoadingPartCM;
